"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFormField = exports.StyledFieldsGroup = exports.StyledFullWidthLegend = exports.StyledErrorText = exports.StyledBasicFieldSet = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const FormFieldWrapper_1 = require("../../../components/Forms/FormFieldWrapper/FormFieldWrapper");
const Tokens = __importStar(require("../../../styles/tokens"));
const Text_1 = require("../../Text/Text");
exports.StyledBasicFieldSet = styled_components_1.default.fieldset `
    border: none;
    margin: 0;
    padding: 0;
`;
exports.StyledErrorText = (0, styled_components_1.default)(Text_1.Text) `
    margin-left: ${Tokens.SIZES[3]};
`;
// Need this so if we pass in a component for the legend then styling works properly
exports.StyledFullWidthLegend = styled_components_1.default.legend `
    width: 100%;
    padding: 0;
`;
exports.StyledFieldsGroup = styled_components_1.default.div `
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0;
    margin: 0;
`;
// This requires a workaround, the reason can be found here
// https://www.notion.so/accurx/Untouched-test-failing-b75c05413d5f4ddc9edb91c7ac1f76db
exports.StyledFormField = (0, styled_components_1.default)((props) => (react_1.default.createElement(FormFieldWrapper_1.FormFieldWrapper, Object.assign({}, props)))) `
    width: 30%;
`;
//# sourceMappingURL=DateOfBirthInput.styles.js.map